import { render, staticRenderFns } from "./CertificateCard.vue?vue&type=template&id=e2537156"
import script from "./CertificateCard.vue?vue&type=script&lang=js"
export * from "./CertificateCard.vue?vue&type=script&lang=js"
import style0 from "./CertificateCard.vue?vue&type=style&index=0&id=e2537156&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports